import React from 'react'
import './styles.scss'
import { UpdateNote } from '@ta-interaktiv/contentbricks'
export const SectionTitle = ({
  main,
  sub,
  update
}: {
  main?: string
  sub?: string | React.ReactChild
  update?: string
}) => {
  return (
    <div className='SectionTitle'>
      {update && (
        <div className='update'>
          <UpdateNote updating={update} />
        </div>
      )}
      <h3>{main && main}</h3>
      <hr />
      {sub && <h4>{sub}</h4>}
    </div>
  )
}
